<script lang="ts">
  import clsx from 'clsx';
  import { type Component } from 'svelte';
  import { getOptimizedImageUrl } from '@athena-lib/Image';
  import { initializeColorContext } from '@athena-lib/container-context.svelte';
  import { getImageContext } from '@athena-lib/Image/context';

  const formatTab = (tab: string) => tab.replace('-', ' ');

  const {
    stickerShopLogoUrl,
    activeTab,
    tabs,
  }: {
    stickerShopLogoUrl: string;
    activeTab?: string;
    tabs: Array<{ name: string; icon: Component; url: string }>;
  } = $props();
  const imageContext = getImageContext();
  initializeColorContext({
    lg: 'light',
    md: 'light',
    sm: 'light',
  });
</script>

<!-- mobile header -->
<div class={clsx('flex flex-row justify-between bg-white lg:hidden')}>
  {#each tabs as tab}
    <a href={tab.url} class="flex max-w-44 flex-grow flex-col items-center px-1 pt-4">
      <tab.icon sizeClass={clsx('h-8 w-8 mb-4')} />
      <span class="mb-3 text-sm font-bold uppercase" class:active={activeTab === tab.name}>
        {formatTab(tab.name)}
      </span>
      <div class={clsx('h-2 w-full max-w-40', activeTab === tab.name && 'bg-st-yellow')}></div>
    </a>
  {/each}
</div>

<!-- desktop header -->
<div class="flex flex-row items-center justify-between max-lg:hidden">
  <img src={getOptimizedImageUrl(stickerShopLogoUrl, imageContext)} alt="Sticker shop logo" />
  <div class="flex flex-row">
    {#each tabs as tab}
      <a href={tab.url} class="flex w-44 flex-col items-center px-6 pt-4">
        <span class="mb-3 text-xl font-bold uppercase" class:active={activeTab === tab.name}>
          {formatTab(tab.name)}
        </span>
        <div class={clsx('h-2 w-full max-w-40', activeTab === tab.name && 'bg-st-yellow')}></div>
      </a>
    {/each}
  </div>
</div>
